/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
 import http from "@/http";
 import * as types from "./types";

 const actions = {
    /**
     * categories: string[]. it's optional.
     * @param {string[]} categories - optional
     * @param {string} size - optional
     * @param {string} component - optional component name to get images from
     * @returns
     */
    [types.GET_CATEGORIES](context, {categories = [], size, component}) {
      let { imageLibrary } = this.state.endPoints.customizer;
      imageLibrary = (imageLibrary) ? imageLibrary : `${this.state.endPoints.ugcentrypoint.ugc}/library`;
      let sku = this.state.utils.pdm?.sku;
      sku = (sku) ? sku : this.state.UGCEntryPoint.selectedStyle;
      const colorMapping = this.state.utils.configuration.image_library?.colorMapping;

      let componentName = !!component ? component : this.state.standardNavigation.activeComponent ;
      componentName = (componentName) ? componentName : this.state.utils.configuration.ugc.models_enabled[sku].components[0];

      let requestUrl = `${imageLibrary}?models=${sku}&components=${componentName}&colorMapping=${colorMapping}`;
      if(categories && categories.length > 0) requestUrl+='&categories='+categories.join();
      if(size) requestUrl+=`&size=${size}`;

      return new Promise((resolve, reject) => {
        http
        .get(context.rootGetters['utils/addCacheBusting'](requestUrl))
        .then(({ data }) => {
          const response = Object.keys(data).map(category => ({
            key: category,
            [category]: data[category],
            isExpanded: false
          }))
          resolve(response);
        })
        .catch(reject);
      });
    },
 };

 export default actions;
